import { components, PlaceholderProps } from 'react-select';
import styled from 'styled-components';
import { ModelEntitySearchResponseItem } from '../../../../../../../../common/model/search/types';

export const CustomPlaceholder = <IsMulti extends boolean>(
  props: PlaceholderProps<ModelEntitySearchResponseItem, IsMulti>,
) => {
  // In calling the root below, need to specify the optionType, since styled-components wrapper does not deduce it.
  return (
    <Root<(props: PlaceholderProps<ModelEntitySearchResponseItem, IsMulti>) => JSX.Element> {...props}>
      <Main>{props.children}</Main>
    </Root>
  );
};

const Root = styled(components.Placeholder)`
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

const Main = styled.div`
  width: 100%;
`;
